import React from 'react';
import { observer } from 'mobx-react';
import { ImportReferenceListTemplate } from 'themes/application/import-reference/pages';
import { setCurrentView } from 'core/utils';
import { ImportReferenceViewStore } from 'application/import-reference/stores';

@setCurrentView((rootStore) => new ImportReferenceViewStore(rootStore), 'listViewStore')
@observer
class ImportReferenceList extends React.Component {
    render() {
        return <ImportReferenceListTemplate {...this.props} />
    }
}

export default ImportReferenceList;